import { Nominal } from "../nominal";

export abstract class BaseEntity<T> extends Nominal<BaseEntity<T>> {
  constructor(readonly value: T) {
    super();
  }

  toJSON(): T {
    return this.value;
  }
}
